import { render, staticRenderFns } from "./UsStep3.vue?vue&type=template&id=93343858&scoped=true&lang=tr"
import script from "./UsStep3.vue?vue&type=script&lang=js"
export * from "./UsStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93343858",
  null
  
)

export default component.exports